import { NSARouterMakerResult } from 'namirasoft-account-react';
import { HistoryEntities } from '../HistoryEntities';
import { HistoryLayout } from '../HistoryLayout';
import { HistoryRouterProps } from '../HistoryRouterProps';
import NSHHistoryChanges from '../component/NSHHistoryChanges';

interface HistoryListPageProps extends NSARouterMakerResult, HistoryRouterProps
{ }

function HistoryListPage(props: HistoryListPageProps)
{
	return (
		<HistoryLayout {...props}
			action={{
				title: "",
				description: "A comprehensive list of all activities, such as deletions and edits, across all products and services.",
				menus: {}
			}}
			pages={{
				entity: HistoryEntities.history(props, []),
				ui: {
					action: {
						menus: {
							view_history: false
						}
					}
				},
				list: {
					ui: {
						tab_page_view: {
							enabled: true,
							tabs: {
								history: false
							}
						},
						getChildrenAfter: (id, entity) =>
						{
							return <NSHHistoryChanges props={props} id={id} row={entity} />;
						}
					}
				}
			}}
		>
			<></>
		</HistoryLayout>

	);
}
export default HistoryListPage;